jQuery(function($){
    if($('.footer_newsletter').length){
        $('.footer_newsletter').parents('.section-wrapper').addClass('newsletter_wrapper');
    }

    $('#header-component.custom_header .menu-list').find('li.menu-list__list-item').each(function(){
        if( $(this).children('.menu-list__submenu').length ){
            setTimeout(() => {
                $(this).addClass('havechild');
            }, 3000);
        }
    });
});

// Remove Blank Accordion
document.addEventListener("DOMContentLoaded", function() {
    document.querySelectorAll('accordion-custom').forEach(function(accordion) {
        const content = accordion.querySelector('.details-content');
        if (content && content.textContent.trim() === "") {
            accordion.remove();
        }
    });

    const firstRemaining = document.querySelector('accordion-custom');
    if (firstRemaining) {
        const details = firstRemaining.querySelector('details');
        if (details) {
            details.open = true;
        }
    }
});